import { useCallback, useContext } from 'react';
import { useHistory, useLocation } from 'react-router-dom';

import { StatusTableContext } from '../contexts';

export const useStatusActionBar = () => {
  const { selection, selectAll, fetch, reset, resetSelection } = useContext(StatusTableContext);

  const location = useLocation();
  const history = useHistory();

  const create = useCallback(() => {
    history.push('/@next/status/create', { background: location });
  }, [history, location]);

  return { selection, resetSelection, create, selectAll, reset, fetch };
};
